import { lazy } from "react";
import { ModuleConfig } from "../../types/ModuleConfig";

const AgentBoardPage = lazy(() => import("./AgentBoardPage"));

/**
 * Agent Board — what Tom's Claude Code agents are doing: the HQ voice connector's job slots, its
 * queue, and every job as a card in Waiting · Running · Needs review · Failed · Reviewed.
 * Built 2026-10-22 because the voice chat can't be woken when a job finishes.
 *
 * `id` MUST equal the backend permissions moduleId ('agent-board') or the navbar silently hides it.
 */
const agentBoardModuleConfig: ModuleConfig = {
  id: "agent-board",
  name: "Agent Board",
  description: "See what your Claude Code agents are doing: job slots, the queue, and results waiting for review",
  version: "0.1.0",
  enabled: true,
  category: "business",
  order: 60,
  icon: "🤖",

  routes: [
    { path: "/agent-board", component: AgentBoardPage, permissionLevel: "view", useLayout: true, layoutOptions: { maxW: "100%" } },
  ],

  navigation: [
    { label: "Agent Board", path: "/agent-board", icon: "🤖", permissionLevel: "view" },
  ],

  // Resolved from the backend SSOT at runtime — ships EMPTY on purpose.
  permissions: { view: [], create: [], edit: [], delete: [] },

  quickActions: [
    { label: "Agent Board", path: "/agent-board", icon: "🤖", description: "What your agents are doing, and what needs review" },
  ],

  changelog: [
    {
      version: "0.1.0",
      releaseDate: "2026-10-22",
      title: "See what your agents are doing",
      features: [
        "Every voice job as a card: Waiting, Running, Needs review, Failed, Reviewed",
        "The slots at a glance: main session, own-session slots, quick read-out slots and the queue",
        "Says plainly when the connector on your laptop has stopped reporting",
        "Mark results reviewed one at a time or all at once; it updates live in every open tab",
      ],
    },
  ],
};

export default agentBoardModuleConfig;
